module.exports = __webpack_public_path__ + "static/media/Prata.cb032089.png";